import { is } from 'ramda';
import { Matrix } from './matrix';
export class LayoutMatrix {
    constructor({ layoutData, cols, defaultSize, isStatic, autolayout = false }) {
        this.configuration = { layoutData, cols, defaultSize, isStatic, autolayout };
        const defaultWidth = cols[defaultSize];
        this.toExternalFormat = this.toExternalFormat.bind(this);
        this.values = {};
        this.matrix = new Matrix(defaultWidth, defaultWidth, null, autolayout);
        this.widgets = layoutData ? this.prepareData(layoutData) : {};
        this.fillMatrix();
    }
    // cache for values
    getValueById(id) {
        if (!this.values[id]) {
            this.values[id] = { id };
        }
        return this.values[id];
    }
    prepareData(data) {
        const layouts = {};
        data.forEach((item) => {
            var _a;
            for (const [size, widget] of Object.entries(item.layout)) {
                const layout = (_a = layouts[size]) !== null && _a !== void 0 ? _a : [];
                layout.push({
                    width: (widget === null || widget === void 0 ? void 0 : widget.w) || 1,
                    height: (widget === null || widget === void 0 ? void 0 : widget.h) || 1,
                    x: widget === null || widget === void 0 ? void 0 : widget.x,
                    y: widget === null || widget === void 0 ? void 0 : widget.y,
                    minH: (widget === null || widget === void 0 ? void 0 : widget.minH) || 1,
                    minW: (widget === null || widget === void 0 ? void 0 : widget.minW) || 5,
                    value: this.getValueById(item.rglId)
                });
                layouts[size] = layout;
            }
        });
        return layouts;
    }
    fillMatrix() {
        const size = String(this.configuration.defaultSize);
        const widgets = this.widgets[size];
        if (typeof widgets !== 'undefined') {
            this.matrix.addWidgets(widgets);
            this.matrix.cutEmptyLines();
        }
    }
    // check that all widgets has coordinates
    hasCoordinates(widgets) {
        return widgets
            ? widgets.every((widget) => {
                return is(Number, widget.x) && is(Number, widget.y);
            })
            : false;
    }
    getWidgets() {
        const sizes = {};
        Object.entries(this.configuration.cols).forEach(([colName, width]) => {
            let matrixContent;
            const widgetsOneSize = this.widgets[colName];
            // if all widgets has coordinates, then skip creating matrix
            if (this.hasCoordinates(widgetsOneSize)) {
                sizes[colName] = widgetsOneSize.map(this.toExternalFormat);
                // if some widgets has not coordinates, create matrix and place all widgets on it
            }
            else if (widgetsOneSize) {
                const matrix = new Matrix(width, width);
                matrix.addWidgets(widgetsOneSize);
                matrixContent = matrix.get();
                sizes[colName] = this.matrix.getWidgets(matrixContent).map(this.toExternalFormat);
                // if there is no layout for this size, then we resize default layout
            }
            else {
                matrixContent = this.matrix.resizeMatrix(width, this.matrix.get());
                sizes[colName] = this.matrix.getWidgets(matrixContent).map(this.toExternalFormat);
            }
        });
        return sizes;
    }
    toExternalFormat(widget) {
        const { value, width, height, minH, minW, x, y } = widget;
        return {
            i: (value === null || value === void 0 ? void 0 : value.id) || '',
            x: x || 0,
            y: y || 0,
            w: width,
            h: height,
            minW: minW,
            minH: minH,
            static: this.configuration.isStatic
        };
    }
}
